export default __webpack_public_path__ + "static/media/connectU-logo1.895835ed.svg";